import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { BASE_PATH_1_PATHNAME, BROWSE_BASE_PATHS } from '@glass/common/modules/pages/paths';
import { BASE_PATH_1_QUERY } from '@glass/common/modules/pages/queryParams';

const isBrowsePage = ({ basePath1, pathname }) =>
  pathname === BASE_PATH_1_PATHNAME && BROWSE_BASE_PATHS.includes(basePath1);

const useIsBrowsePage = () => {
  const {
    pathname,
    query: { [BASE_PATH_1_QUERY]: basePath1 },
  } = useRouter();
  return useMemo(() => isBrowsePage({ basePath1, pathname }), [basePath1, pathname]);
};

export default useIsBrowsePage;
